import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { required, email } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../Components/Forms/renders";

const normalizePhone = (value) => {
  if (!value) return value;

  // Verwijder spaties en streepjes
  let phone = value.replace(/[\s-]/g, '');

  // Als het begint met 0, vervang door +31
  if (phone.startsWith('0')) {
    phone = '+31' + phone.substring(1);
  }
  // Als het begint met 31 (zonder +), voeg + toe
  else if (phone.startsWith('31') && !phone.startsWith('+')) {
    phone = '+' + phone;
  }

  return phone;
};

const SwimmingPoolForm = (props) => {
  const { handleSubmit, pristine, submitting } = props;

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <h4>Zwembad Gegevens</h4>
              <Field
                name="name"
                type="input"
                validate={[required()]}
                component={renderField}
                label="Naam Zwembad"
              />

              <Field
                name="pool_type"
                type="input"
                validate={[required()]}
                component={renderselect}
                options={{
                  openbaar: "Openbaar",
                  prive: "Privé",
                  sportschool: "Sportschool",
                  hotel: "Hotel",
                  camping: "Camping",
                  wellness: "Wellness",
                  overig: "Overig"
                }}
                label="Type Zwembad"
              />

              <Field
                name="registration_number"
                type="input"
                component={renderField}
                label="Registratienummer (optioneel)"
              />

              <h4 className="mt-4">Adresgegevens</h4>
              <Field
                name="street"
                type="input"
                component={renderField}
                label="Straat"
              />

              <div className="row">
                <div className="col-md-4">
                  <Field
                    name="house_number"
                    type="input"
                    component={renderField}
                    label="Huisnummer"
                  />
                </div>
                <div className="col-md-4">
                  <Field
                    name="postal_code"
                    type="input"
                    component={renderField}
                    label="Postcode"
                  />
                </div>
                <div className="col-md-4">
                  <Field
                    name="city"
                    type="input"
                    component={renderField}
                    label="Plaats"
                  />
                </div>
              </div>

              <h4 className="mt-4">Contactgegevens</h4>
              <Field
                name="contact_name"
                type="input"
                component={renderField}
                label="Contactpersoon"
              />

              <Field
                name="contact_email"
                type="email"
                validate={[email()]}
                component={renderField}
                label="E-mailadres"
              />

              <Field
                name="contact_phone"
                type="input"
                component={renderField}
                normalize={normalizePhone}
                label="Telefoonnummer"
              />

              <Field
                name="notes"
                type="input"
                component={renderTextField}
                label="Opmerkingen"
              />

              <Field
                name="is_active"
                type="input"
                component={renderselect}
                options={{
                  true: "Actief",
                  false: "Inactief"
                }}
                label="Status"
              />
            </div>
          </div>

          <div className="pull-left submit mt-3">
            <button
              type="submit"
              className="btn btn-success btn-wd"
              disabled={pristine || submitting}
            >
              Opslaan
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

let ReduxSwimmingPoolForm = reduxForm({
  form: "swimming_pool_form",
  enableReinitialize: true
})(SwimmingPoolForm);

ReduxSwimmingPoolForm = connect((state) => ({
  initialValues: state.zwembadinspecties.swimmingPoolCompany || {
    is_active: true,
    pool_type: 'openbaar'
  }
}))(ReduxSwimmingPoolForm);

export default ReduxSwimmingPoolForm;
